import React from 'react';
import styles from './RestartScrimProcessing.module.css';

interface RestartScrimProcessingProps {
  isOpen: boolean;
  onClose: () => void;
  onRestart: () => void;
  isRestarting: boolean;
}

const RestartScrimProcessing: React.FC<RestartScrimProcessingProps> = ({
  isOpen,
  onClose,
  onRestart,
  isRestarting
}) => {
  if (!isOpen) return null;

  return (
    <div className={styles.modal}>
      <div className={styles.modalContent}>
        <h3>Restart Processing</h3>
        <p>
          Processing may fail due to server issues or YouTube connection problems. 
          Restarting often fixes these issues.
        </p>
        <p>
          <strong>Note:</strong> Your existing notes will not be affected.
        </p>
        <div className={styles.modalActions}>
          <button 
            className={styles.cancelButton}
            onClick={onClose}
            disabled={isRestarting}
          >
            Cancel
          </button>
          <button 
            className={styles.restartButton}
            onClick={onRestart}
            disabled={isRestarting}
          >
            {isRestarting && <div className={styles.buttonSpinner}></div>}
            Restart
          </button>
        </div>
      </div>
    </div>
  );
};

export default RestartScrimProcessing; 